import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

function RouteFooter() {

    const { t } = useTranslation()
    return (
        <>
            <Stack direction={{ xs: "column", sm: "row" }} sx={{ justifyContent: 'center' }} gap={2}>
                <Link
                    to="/"
                    style={{
                        color: "#FFF",
                        textDecoration: "none",
                        fontSize: '1.5rem',

                    }}
                >
                    <Typography fontWeight={"bold"} sx={{ fontSize: '1.5rem' }} >{t('linksPages.home')}</Typography>
                </Link>
                <Link
                    to="/about"
                    style={{
                        color: "#FFF",
                        textDecoration: "none",
                        fontSize: '1.5rem',

                    }}
                >
                    <Typography fontWeight={"bold"} sx={{ fontSize: '1.5rem' }} >{t('linksPages.aboutUs')}</Typography>
                </Link>
                <Link
                    to="/contact"
                    style={{
                        color: "#FFF",
                        textDecoration: "none",
                        fontSize: '1.5rem',
                        fontWeight: "bold",
                    }}
                >

                    <Typography fontWeight={"bold"} sx={{ fontSize: '1.5rem' }} >{t('linksPages.contact')}</Typography>
                </Link>
                <Link
                    to="/service"
                    style={{
                        color: "#FFF",
                        textDecoration: "none",
                        fontSize: '1.5rem',
                        fontWeight: "bold",
                    }}
                >
                    <Typography fontWeight={"bold"} sx={{ fontSize: '1.5rem' }} >{t('linksPages.PhotoGallery')}</Typography>
                </Link>
            </Stack>

            <Box flexDirection={'column'} textAlign={'center'} gap={2} display={'flex'} >
                <Typography fontWeight={"bold"} sx={{ fontSize: '1.5rem', color: '#FFF' }} >{t('copeRight')}</Typography>
                <Typography fontWeight={"bold"} sx={{ fontSize: '1.4rem' }} color={'#FFF'} > <Link to={'https://revampbrands.com/'} style={{ textDecoration: "none", color: "#FFF" }} >{t('div')}</Link> </Typography>
            </Box>
        </>
    )
}

export default RouteFooter